import React from 'react';
import { Link, useParams } from 'react-router-dom';
import DispatchPos from '../components/DispatchPos';
import InlineLoading from '../components/InlineLoading';
import useCurrentUser from '../hooks/useCurrentUser';
import usePrincipalDispatch from '../hooks/usePrincipalDispatch';

export default function DispatchPage() {
  const { branchId } = useParams();
  const { user } = useCurrentUser();
  const { eligible, loading, error, retry, origins, defaultOriginBranchId } = usePrincipalDispatch(branchId, user);

  if (!user || loading) return <div className="p-6"><InlineLoading label="Cargando despacho" /></div>;
  if (error) return <main className="space-y-3 p-6"><p role="alert">{error}</p><button type="button" className="min-h-11 rounded-xl border px-4" onClick={retry}>Reintentar</button></main>;
  if (!eligible) return <main className="space-y-3 p-6"><h1 className="text-xl font-bold">Despachos</h1><p>No tienes permiso para despachar desde esta sucursal.</p><Link className="inline-flex min-h-11 items-center text-blue-700 underline" to="/home">Volver al inicio</Link></main>;
  return <DispatchPos key={`${user.selectedCompanyId}:${branchId}`} branchId={defaultOriginBranchId || branchId} origins={origins} />;
}
